import { defineComponent as _defineComponent } from 'vue'
import { useAuthStore } from '@/app/store/authStore';
import AppBanner from '@/app/components/common/AppBanner.vue';
import { computed } from 'vue';
import { useWalletsStore } from '@/app/store/walletsModule';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import { useRoute } from 'vue-router/composables';
import { inheritedMeta } from 'ah-common-lib/src/helpers/router';
import { ACTIVE_MARGIN_CALL_BANNER_META_FLAG } from '@/app/constants/banners';
import { ClientRiskProfileReport, FeatureFlag } from 'ah-api-gateways';
import { useFeatureFlag } from 'ah-common-stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActiveMarginCallBanner',
  setup(__props) {

const authStore = useAuthStore();

const route = useRoute();

const walletStore = useWalletsStore();

const onBehalfOfClient = useOnBehalfOf();

const clientId = computed(() => onBehalfOfClient.value?.id ?? authStore.loggedInIdentity?.client?.id);

const isNewTradeScreen = computed(() => inheritedMeta(route)[ACTIVE_MARGIN_CALL_BANNER_META_FLAG]);

const { isActive: isVariationMarginFeatureActive } = useFeatureFlag({
  featureFlag: FeatureFlag.VARIATION_MARGIN_AND_LIMITS_FEATURE,
});

const clientRiskProfileReportData = computed<ClientRiskProfileReport | null>(() => {
  if (clientId.value) {
    return walletStore.getClientRiskProfile(clientId.value);
  }
  return null;
});

const limitsAndCollateralLink = computed(() => {
  if (authStore.isClientUser) {
    return '/dashboard/trades/limits-collateral';
  } else {
    return `admin/activity/clients/obo/${onBehalfOfClient.value?.id}/trade`;
  }
});

const showActiveMarginCallBanner = computed(
  () =>
    isNewTradeScreen.value &&
    isVariationMarginFeatureActive.value &&
    clientRiskProfileReportData.value?.collateralProfile.activeMarginCall
);

return { __sfc: true,authStore, route, walletStore, onBehalfOfClient, clientId, isNewTradeScreen, isVariationMarginFeatureActive, clientRiskProfileReportData, limitsAndCollateralLink, showActiveMarginCallBanner, AppBanner }
}

})